module.exports = __WEBPACK_EXTERNAL_MODULE__mfe_mfe_report_remoteEntry_mjs_1e5f89b5__;